import useLocalState from "./useLocalState";

export default function useLang() {
  return useLocalState("yana:lang:v1", "en");
}
